import Swal from "sweetalert2";
import { api } from "../api/Middleware";
import {
  ACCOUNT_URL,
  SUPPORT_URL,
  SECURITY_URL,
  GOOGLE_API_URL,
} from "../api/Urls";
import { ERROR_MESSAGES } from "../helpers/ErrorMessages";

export const GetOne = async (
  account_id,
  setStore,
  setErrors,
  setIsLoading,
  clean_cache = false,
  returnData = false
) => {
  try {
    let response = await api.get(
      `${ACCOUNT_URL}${account_id}/?cc=${clean_cache}`
    );
    if (response.status === 200) {
      if (returnData) return response.data;
      setStore(response.data);
      setIsLoading(false);
    }
  } catch (error) {
    setErrors({ title: "Oops!", message: ERROR_MESSAGES.store.get });
  }
};

export const GetSettings = async () => {
  try {
    let response = await api.get(`${ACCOUNT_URL}settings/`);
    return response.data;
  } catch (error) {
    Swal.fire({
      title: "Oops!",
      html: error.response.data,
      icon: "warning",
      toast: true,
      position: "bottom-end",
      timer: 2500,
    });
    return;
  }
};

export const List = async (
  url,
  setStores,
  setErrors,
  setIsLoading,
  clean_cache = false
) => {
  try {
    let response = await api.get(`${ACCOUNT_URL}all/`);
    if (response.status === 200) {
      if (response.data && response.data.length > 0) {
        response.data = response.data.reverse();
      }

      setStores(response.data);
    }
  } catch (error) {
    setErrors({ title: "Oops!", message: ERROR_MESSAGES.store.get });
  } finally {
    if (setIsLoading) {
      setIsLoading(false);
    }
  }
};

export const CheckCpfCnpj = async (cpf_cnpj) => {
  try {
    let response = await api.get(
      `${ACCOUNT_URL}check_cpf_cnpj/?cpf_cnpj=${cpf_cnpj}`
    );
    if (response.status === 200) return response;
  } catch (error) {
    if (error.response.status === 403) {
      Swal.fire({
        title: "Oops!",
        html: error.response.data,
        icon: "info",
        buttons: true,
        confirmButtonText: `Fazer Login agora`,
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        confirmButtonColor: "var(--primary)",
      }).then((value) => {
        if (value.isConfirmed) {
          window.location.href = "/login";
        }
      });
    }
  }
};

export const CreateSupportTicket = async (data) => {
  try {
    let response = await api.post(`${SUPPORT_URL}`, data);
    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        title: "Sucesso!",
        html: "Cadastramos seu ticket de support, em até 24h você será notificado.",
        icon: "success",
      }).then((value) => {
        if (value.isConfirmed) {
          window.location.reload();
        }
      });
    }
  } catch (error) {
    console.log(error.response);
    Swal.fire({
      title: "Oops!",
      html: error.response.data,
      icon: "warning",
    }).then((value) => {
      if (value.isConfirmed) {
        window.location.reload();
      }
    });
  }
};

export const GetSupportTickets = async (
  setSupportTickets,
  setNotify,
  setIsLoading
) => {
  try {
    let response = await api.get(`${SUPPORT_URL}`);
    if (response.status === 200) {
      setSupportTickets(response.data.results);
    }
  } catch (error) {
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
  } finally {
    setIsLoading(false);
  }
};

/* export const WACampaignsTermsOfUse = async (id, data, setShowModal) => {
  try {
    let response;
    if (id) {
      response = await api.put(`${STORE_CONFIGS_URL}${id}/`, data);
    } else {
      response = await api.post(`${STORE_CONFIGS_URL}`, data);
    }
    if (response.status === 200 || response.status === 201) {
      setShowModal(false);
      Swal.fire(
        "Sucesso!",
        "Você aceitou os termos de uso e está apto a utilizar a ferramenta!",
        "success"
      ).then((res) => {
        if (res.isConfirmed) {
          window.location.href = "/campaigns";
        }
      });
    }
  } catch (error) {
    console.log(error);
    Swal.fire(
      "Oops!",
      "Não conseguimos concluir esta ação, por favor, tente novamente daqui alguns minutos, caso o problema persista, contacte nosso setor de suporte.",
      "warning"
    );
  }
}; */

/* export const GetPlansFeatures = async () => {
  try {
    let response = await api.get(`${PLANS_URL}get_features/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
}; */

export const FindPlace = async (input) => {
  try {
    const response = await api.get(GOOGLE_API_URL + `places-autocomplete/`, {
      params: { input },
    });
    return response.data.predictions;
  } catch (error) {
    console.error("Erro na busca de lugares:", error);
    return [];
  }
};

export const GetPlaceDetails = async (placeId) => {
  try {
    const response = await api.get(GOOGLE_API_URL + `place-details/`, {
      params: { place_id: placeId },
    });
    return response.data.result;
  } catch (error) {
    console.error("Erro ao obter detalhes do lugar:", error);
    return null;
  }
};
